import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isCapacitorNative } from '../mobile/oauthDeepLink';
import { isElectronClient } from '../utils/isElectronClient';
import { isPhysicalMobileGameViewport } from '../utils/isPhysicalMobileGameViewport';
import { useBrowserFullscreen } from '../hooks/useBrowserFullscreen';
import {
  isWebFullscreenBannerDismissed,
  markWebFullscreenBannerDismissed,
} from './browserFullscreen';
import './WebFullscreenPrompt.css';

function shouldOfferWebFullscreen() {
  if (isElectronClient()) {
    return false;
  }
  if (isCapacitorNative()) {
    return false;
  }
  if (isPhysicalMobileGameViewport()) {
    return false;
  }
  return true;
}

function WebFullscreenPrompt({ enabled = true }) {
  const { t } = useTranslation();
  const { supported, isActive, enter } = useBrowserFullscreen();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!enabled || !shouldOfferWebFullscreen() || !supported) {
      setVisible(false);
      return;
    }
    if (isActive || isWebFullscreenBannerDismissed()) {
      setVisible(false);
      return;
    }
    setVisible(true);
  }, [enabled, supported, isActive]);

  const handleEnter = async () => {
    try {
      await enter();
    } catch (err) {
      console.error('Web fullscreen enter failed:', err);
    }
  };

  const handleDismiss = () => {
    markWebFullscreenBannerDismissed();
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="web-fullscreen-prompt"
      role="region"
      aria-label={t('fullscreen.webPromptAria')}
    >
      <p className="web-fullscreen-prompt__text">{t('fullscreen.webPromptBody')}</p>
      <div className="web-fullscreen-prompt__actions">
        <button
          type="button"
          className="web-fullscreen-prompt__enter"
          onClick={handleEnter}
        >
          {t('fullscreen.webPromptEnter')}
        </button>
        <button
          type="button"
          className="web-fullscreen-prompt__dismiss"
          onClick={handleDismiss}
        >
          {t('common.notNow')}
        </button>
      </div>
    </div>
  );
}

export default WebFullscreenPrompt;
